import React from 'react';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { Row, Col, Image, DropdownButton, MenuItem } from 'react-bootstrap';
import edgeLogo from '../static/edgelogo.png';
import setting_icon from '../static/Setting.png';
import mobileTab from '../static/mobileTab.svg';
import { urlCheck, specialCheck } from '../util/utils';

function thumbnail(course, courseId) {
  if (course.id === courseId) {
    return (
      <MenuItem
        eventKey={course.id}
        key={course.id}
        className='selected'
        disabled
      >
        <Image src={course.thumbnail} />
        <span>{course.name}</span>
      </MenuItem>
    );
  } else {
    return (
      <MenuItem eventKey={course.id} key={course.id}>
        <Image src={course.thumbnail} />
        <span>{course.name}</span>
      </MenuItem>
    );
  }
}

function dropdownItem(route, title) {
  return (
    <LinkContainer to={route}>
      <MenuItem>{title}</MenuItem>
    </LinkContainer>
  );
}

const Setting = ({ state, handlers }) => {
  const { course, setting, userState, userId, courses, courseId } = state;
  const {
    onToggle,
    courseOpen,
    courseClose,
    settingOpen,
    settingClose,
    onLogOut,
    onCourseClick
  } = handlers;

  const activeCourses = courses.filter(val => val.is_active);
  const selectedCourse =
    activeCourses.filter(val => val.id === courseId)[0] || {};

  return (
    <div className='nav_right'>
      {userState === 'basic' && (
        <div className='upg'>
          <a
            className='btn-upgrade'
            href='http://edge.themusio.com/intro#section_p5'
          >
            Premiumにアップグレード
          </a>
        </div>
      )}
      <div className='dropdown_section'>
        <div className='dropdown_contents'>
          <DropdownButton
            id='contents_dropdown'
            noCaret
            title={
              <img
                src={selectedCourse['thumbnail']}
                alt={selectedCourse['name']}
              />
            }
            open={course}
            onToggle={onToggle}
            onSelect={onCourseClick}
            onMouseEnter={courseOpen}
            onMouseLeave={courseClose}
          >
            <MenuItem disabled>学習中</MenuItem>
            {activeCourses.map(course => thumbnail(course, courseId))}
          </DropdownButton>
        </div>
        <div className='dropdown_contents'>
          <DropdownButton
            id='setting_dropdown'
            noCaret
            title={<img src={setting_icon} alt='setting' />}
            open={setting}
            onToggle={onToggle}
            onMouseEnter={settingOpen}
            onMouseLeave={settingClose}
          >
            <MenuItem disabled>{userId}</MenuItem>
            {dropdownItem('/mypage', 'マイアカウント')}
            {dropdownItem('/forum', 'コミュニティー')}
            <MenuItem divider />
            <MenuItem eventKey='9' onClick={onLogOut}>
              Log Out
            </MenuItem>
          </DropdownButton>
        </div>
      </div>
    </div>
  );
};

export const SideNav = ({ sideNav, handler, logout, userState }) => {
  return (
    <div id='side_nav' className={sideNav ? 'clicked' : 'unclicked'}>
      <Link to='/dashboard'>ダッシュボード</Link>
      <DropdownButton title='Premium' id='bg-nested-dropdown' noCaret>
        {dropdownItem('/premium', '- AI')}
        {dropdownItem('/premium/coach', '- Coaching')}
        {userState === 'pro' ? (
          <MenuItem href='https://jp.glats.online/'>- Gakken Eng</MenuItem>
        ) : (
          <MenuItem disabled>- Gakken Eng</MenuItem>
        )}
      </DropdownButton>
      <div className='side-bar'>
        <div />
      </div>
      <Link to='/mypage'>マイアカウント</Link>
      <Link to='/forum'>コミュニティー</Link>
      <Link to='/dashboard' onClick={logout}>
        Log Out
      </Link>
      {userState === 'basic' && (
        <a
          className='btn-upgrade'
          href='http://edge.themusio.com/intro#section_p5'
        >
          Premiumにアップグレード
        </a>
      )}
    </div>
  );
};

const ProSection = ({ state, handlers }) => {
  return (
    <DropdownButton
      className={urlCheck(state.location, '/premium')}
      title='Premium'
      id='bg-nested-dropdown'
      open={state.pro}
      noCaret
      onMouseEnter={handlers.handleProOpen}
      onMouseLeave={handlers.handleProClose}
      onToggle={handlers.onToggle}
    >
      <LinkContainer to='/premium'>
        <MenuItem
          eventKey='1'
          onClick={handlers.onProClick}
          className={specialCheck(state.location)}
        >
          AI
        </MenuItem>
      </LinkContainer>
      <LinkContainer to='/premium/coach'>
        <MenuItem
          eventKey='2'
          onClick={handlers.onProClick}
          className={urlCheck(state.location, '/premium/coach')}
        >
          Coach
        </MenuItem>
      </LinkContainer>
      {state.userState === 'pro' ? (
        <MenuItem href='https://jp.glats.online/'>Gakken Eng</MenuItem>
      ) : (
        <MenuItem disabled>Gakken Eng</MenuItem>
      )}
    </DropdownButton>
  );
};

export const Navbar = ({ state, handlers }) => {
  return (
    <section id='header'>
      <div className='container'>
        <Row>
          <Col xs={2}>
            <div className='nav_brand'>
              <Link to='/'>
                <input
                  className='brand-img'
                  type='image'
                  src={edgeLogo}
                  alt='EdgeLogo'
                />
              </Link>
            </div>
          </Col>
          <Col
            className='hidden-xs nav_center'
            style={{ display: 'inline-block' }}
          >
            <div className='nav_menu'>
              <Link
                to='/dashboard'
                className={'btn ' + urlCheck(state.location, '/dashboard')}
                onMouseEnter={handlers.dashboardEnter}
                onMouseLeave={handlers.dashboardLeave}
              >
                ダッシュボード
              </Link>
              <ProSection state={state} handlers={handlers} />
            </div>
          </Col>
          <Col className='hidden-xs nav_side' style={{ float: 'right' }}>
            <Setting state={state} handlers={handlers} />
          </Col>
          <Col xs={1} style={{ float: 'right' }}>
            <div className='mobile-nav'>
              <div className='closed-button'>
                <input
                  type='image'
                  src={mobileTab}
                  alt='mobile-tab'
                  onClick={handlers.onSideNavClick}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/components/Navbar.js